export default __webpack_public_path__ + "static/media/image6.0969212b.jpeg";